<template>
  <div id="pending-tree-grid" class="grid-view">
    <div class="main-content">
      <search-item
        ref="searchItem"
        config-module="90100"
        :show-adv="true"
        :expand-adv="expandAdv"
        :custom-search-items="customSearchItems"
        :search-item-code="$t('SeaExport.PendingPickingOrder')"
        :custom-sim-query-placeholder="$t('SeaExport.QuickSearchMBL')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button v-if="!(pickingOrder && pickingOrder.pickingOrderKey)" no="PickingList" type="primary" @click="generatePicking(0)">{{ $t('SeaExport.GenerateAPickingList') }}</el-button>
          <el-button v-if="!(pickingOrder && pickingOrder.pickingOrderKey)" no="IssueOrders" type="primary" @click="generatePicking(1)">{{ $t('SeaExport.GenerateAndIssueOrders') }}</el-button>
          <el-button no="expandAll" type="primary" @click="expandAll()">{{ $t('queryJob.expandAll') }}</el-button>
          <el-button no="putItAllAway" type="primary" @click="putItAllAway()">{{ $t('queryJob.putItAllAway') }}</el-button>
          <!--打印-->
          <el-button no="print" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:550px">
        <cargo-ag-grid
          config-module="90101"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :deselect-sub-record="true"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="90101"
          :total="total"
          :page.sync="filterJson.pageNum"
          :limit.sync="filterJson.pageSize"
          @pagination="toQueryByPage"
        />
      </div>
    </div>
    <!-- 生成拣货单弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="pickingDialog.visible"
      :title="$t('SeaExport.SuccessfullyGenerated')"
      width="300px"
      :close-on-click-modal="false"
    >
      <div>
        <span>{{ $t('SeaExport.ThisPickingOrderNoIs') }}</span>
        <span style="margin: 0 10px;font-size:18px;color:#1F75D5">{{ pickingDialog.pickingOrderNo }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="onPrintHandler(pickingDialog.pickingOrderKey)">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button type="primary" @click="confirmCopy">{{ $t('SeaExport.CloseAndCopyPickingOrderNo') }}</el-button>
        <el-button no="33" @click="pickingDialog.visible=false">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import {
  preWarehouseAdvancedQuery,
  savePickingOrder
} from '@/api/warehouseIn/warehouseIn'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { cacheName, cache } from '@/utils/cacheManager'
import { stringToBool } from '@/utils/commonUtil'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { IMPERIAL_6 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'Pending',
  components: { searchItem },
  props: {
    pickingOrder: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        treeData: true,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.MasterBillNo'),
          colId: 'mbl',
          field: 'mbl',
          width: 140,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: params => {
            return true
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              const curData = params.data
              if (curData && curData.hasOwnProperty('dataType') && Number(curData.dataType) === 1) {
                const mblValue = ColumnUtils.mawbNoLabelFun(curData.mbl, this.airMblDisplayStyle)
                return `<span>${mblValue}</span>`
              }
              return `<span></span>`
            }
          }
        }
      },
      gridParams: {},
      customSearchItems: [],
      rowData: [],
      isAdvancedQuery: false, // 是否为高级查询
      openImperial: false, // 英制单位
      total: 0,
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        pageNum: 1,
        pageSize: 10,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: []
      },
      airMblDisplayStyle: false, // 空运主单号格式
      pickingDialog: {
        visible: false,
        pickingOrderKey: '',
        pickingOrderNo: ''
      }
    }
  },
  computed: {
    expandAdv() {
      return !!(this.pickingOrder && this.pickingOrder.warehouse)
    },
    columnDefs() {
      const list = [
        {
          headerName: this.$t('SeaExport.JobNo'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.BoardNumber'),
          field: 'palletNumber',
          colId: 'palletNumber',
          width: 140,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 3) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          width: 140,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.AssemblyPlanNumber'),
          field: 'assemlyPlanNo',
          colId: 'assemlyPlanNo',
          width: 140,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Warehouse'),
          field: 'warehouse',
          colId: 'warehouse',
          width: 150,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 1 || Number(params.data.dataType) === 2)) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.DeliveryStation'),
          field: 'deliveryStation',
          colId: 'deliveryStation',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 1 || Number(params.data.dataType) === 2)) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.WarehouseEntryNumber'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && Number(params.data.dataType) === 2) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('Warehouse.WarehouseLocation'),
          field: 'storageLocationName',
          colId: 'storageLocationName',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 2 || Number(params.data.dataType) === 3)) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Flight'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 1 || Number(params.data.dataType) === 2)) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FlightDate'),
          field: 'voyageFlightDate',
          colId: 'voyageFlightDate',
          width: 120,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 1 || Number(params.data.dataType) === 2)) {
              return params.value
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.OutboundInstruction'),
          field: 'outboundStatus',
          colId: 'outboundStatus',
          width: 100,
          valueFormatter: (params) => {
            if (params.data && params.data.dataType && (Number(params.data.dataType) === 1 || Number(params.data.dataType) === 2)) {
              return ColumnUtils.booleanLabelFunction(stringToBool(params.value === 1))
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantity',
          colId: 'quantity',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weight',
          colId: 'weight',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubage',
          colId: 'cubage',
          width: 100
        }
      ]
      if (this.openImperial) {
        list.push({
          headerName: this.$t('SeaExport.Weight') + 'LB',
          field: 'weightImperial',
          colId: 'weightImperial',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Cubage') + 'CFT',
          field: 'cubAgeImperial',
          colId: 'cubAgeImperial',
          width: 100
        })
      }
      return list
    }
  },
  created() {
    this.initConfig()
  },
  methods: {
    // 初始化一些 config表的配置信息
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.airMblDisplayStyle = Number(cache.config.get('AirMblDisplayStyle')) === 1
      this.customSearchItems = await this.getCustomSearchItems()
      await JobUtils.initImperialData(IMPERIAL_6.code).then(r => {
        this.openImperial = r
      })
    },
    // 查询[简单查询/高级查询]
    toQuery() {
      this.filter.pageNum = 1
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery(this.filter.snapshotConditions)
      } else {
        this.toSimpleQuery()
      }
    },
    // 高级查询
    toAdvancedQuery(data) {
      this.filter.mbl = ''
      this.filter.conditions = []
      this.filter.lob = SystemConstants.AE.code
      if (typeof data !== 'undefined') {
        this.filter.snapshotConditions = [...data] // 高级查询条件（点击查询时的快照状态）
        this.filter.conditions = [...data]
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.loading = getLoading4Cxt()
      preWarehouseAdvancedQuery(this.filter).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 简单查询
    toSimpleQuery(keyword) {
      this.loading = getLoading4Cxt()
      if (typeof keyword !== 'undefined') {
        this.filter.mbl = keyword.trim()
        this.filter.pageNum = 1
        this.filter.lob = SystemConstants.AE.code
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      const conditions = []
      this.filter.conditions = conditions
      preWarehouseAdvancedQuery(this.filter).then(res =>
        this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    async getCustomSearchItems() {
      const defaultSearchFields = []
      const operations = getCacheListByKey(basicCacheKeys.basic_data_AirportCargoTerminal)
      const warehouseOperations = operations.filter(data => data.dataType === 1)
        .map(item => ({
          code: item.uuid,
          chineseName: item.warehouseName,
          englishName: item.warehouseName
        }))
      const defaultWarehouse = []
      if (this.pickingOrder && this.pickingOrder.warehouse) {
        const curWarehouse = warehouseOperations.filter(data => data.chineseName === this.pickingOrder.warehouse)
        if (curWarehouse && curWarehouse.length > 0) {
          defaultWarehouse.push(curWarehouse[0].code)
        }
      }
      let searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airExportJob.FRONT_END_WAREHOUSE_OPERATION'
      searchField.itemLabel = 'CargoMsg.Cargo_Warehouse'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.dropdownDataRef = ''
      searchField.tagName = 'warehouseName'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = defaultWarehouse
      searchField.dataProvider = warehouseOperations
      defaultSearchFields.push(searchField.formatObj2Json())

      const stationOperations = operations.filter(data => data.dataType === 0)
        .map(item => ({
          code: item.uuid,
          chineseName: item.warehouseName,
          englishName: item.warehouseName
        }))
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 0
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'airExportJob.CARGO_TERMINAL_OPERATION'
      searchField.itemLabel = 'SeaExport.DeliveryStation'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.tagName = 'warehouseName'
      searchField.tagValue = 'uuid'
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = stationOperations
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    // 生成拣货单 0 仅生成 1生成并出单
    generatePicking(outbound) {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const rows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 3))
      // 仓库货站必须相同
      const curWarehouseName = rows[0].warehouse
      const curDeliveryStation = rows[0].deliveryStation
      const hasJob = new Set()
      for (const item of rows) {
        if (curWarehouseName !== item.warehouse) {
          this.$message.warning(this.$t('SeaExport.PleaseCheckSameDataWareHouse'))
          return
        }
        if (curDeliveryStation !== item.deliveryStation) {
          this.$message.warning(this.$t('SeaExport.DifferentGoodsCannotSamePickingList'))
          return
        }
        if (item.outboundStatus === 0) {
          hasJob.add(item.jobNo)
        }
      }
      if (hasJob.size > 0) {
        this.$confirm(this.$t('CargoMsg.Cargo_NoOutboundCommandConfirmPickList', [[...hasJob].join(',')]), this.$t('CargoMsg.Cargo_ConfirmR')).then(() => {
          this.doGeneratePicking(rows, outbound)
        })
      } else {
        this.doGeneratePicking(rows, outbound)
      }
    },
    doGeneratePicking(rows, outbound) {
      const detailKeys = []
      rows.forEach(item => {
        detailKeys.push(item.uuid)
      })
      const payload = {
        detailKeys: detailKeys,
        warehouse: rows[0].warehouse,
        branchId: this.$store.getters.currentOfficeId,
        outbound: outbound
      }
      this.loading = getLoading4Cxt()
      savePickingOrder(payload).then(res => {
        if (res.ok) {
          // this.generatePickingSuccess(res)
          this.pickingDialog.visible = true
          this.pickingDialog.pickingOrderNo = res.data['pickingOrderNo']
          this.pickingDialog.pickingOrderKey = res.data['uuid']
        } else {
          this.$message.error(this.$t('AirExport.GenerationFailed'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    generatePickingSuccess(res) {
      const pickingOrderNo = res.data['pickingOrderNo']
      const h = this.$createElement
      const content = h('div', null, [
        h('p', null, [
          h('span', null, this.$t('SeaExport.ThisPickingOrderNoIs')),
          h('span', { style: 'margin: 0 10px;font-size:18px;color:#1F75D5' }, pickingOrderNo)
        ])
      ])
      this.$confirm(content, this.$t('SeaExport.SuccessfullyGenerated'), {
        confirmButtonText: this.$t('SeaExport.CloseAndCopyPickingOrderNo'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Close'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        distinguishCancelAndClose: true,
        customClass: 'message-box-width-450',
        type: 'success'
      }).then(() => {
        let input = document.createElement('input')
        document.body.appendChild(input)
        input.setAttribute('value', pickingOrderNo)
        input.select()
        if (document.execCommand('copy')) {
          document.execCommand('copy')
          this.$message.success(this.$t('SeaExport.CopySuccess'))
        }
        document.body.removeChild(input)
        input = null
      }).finally(() => {
        this.toQuery()
      })
    },
    getSelectRows() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const rows = selectedRows.filter(p => p.hasOwnProperty('dataType') && (Number(p.dataType) === 3))
      // 仓库货站必须相同
      for (const item of rows) {
        if (this.pickingOrder.warehouse !== item.warehouse) {
          this.$message.warning(this.$t('SeaExport.PleaseCheckSameDataWareHouse'))
          return
        }
        if (this.pickingOrder.deliveryStation !== item.deliveryStation) {
          this.$message.warning(this.$t('SeaExport.DifferentGoodsCannotSamePickingList'))
          return
        }
      }
      return rows
    },
    expandAll() {
      this.gridOptions.groupDefaultExpanded = 3
      this.gridApi.expandAll()
    },
    putItAllAway() {
      this.gridOptions.groupDefaultExpanded = 0
      this.gridApi.collapseAll()
    },
    // 确认且复制
    confirmCopy() {
      let input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.pickingDialog.pickingOrderNo)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
      input = null
      this.pickingDialog.visible = false
      this.toQuery()
    },
    // 打印
    onPrintHandler(pickingOrderKey) {
      const warehouseInUuids = []
      const pickingOrderKeys = []
      if (pickingOrderKey) {
        pickingOrderKeys.push(pickingOrderKey)
      }
      const selectedRows = this.gridApi.getSelectedRows()
      for (const selectedRow of selectedRows) {
        if (selectedRow.dataType === 3 && !warehouseInUuids.includes(selectedRow.warehouseInUuid)) {
          warehouseInUuids.push(selectedRow.warehouseInUuid)
        }
      }
      if (!warehouseInUuids || warehouseInUuids.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectTheDesiredPrintInformation'))
        return
      }
      this.$emit('print', warehouseInUuids, pickingOrderKeys)
    }
  }
}
</script>

<style scoped>

</style>
